import React from "react";
import { CircularProgress } from "@mui/material";
import { logFunctions as log } from "../../util/Logging";

function FallbackLoadingScreen() {
  log.debug("+FallbackLoadingScreen(TRACE)");
  log.debug("-FallbackLoadingScreen(TRACE)");
  return (
    <div className="Screen">
      <div className="fallbackLoadingContainer">
        <div className="loadingTextBox">
          <div className="loaderIcon" id="loaderIcon">
            <CircularProgress size={"100px"} id="circularProgressIcon" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FallbackLoadingScreen;
